import { render } from "./WalletDeposit.vue?vue&type=template&id=ce788260&scoped=true"
import script from "./WalletDeposit.vue?vue&type=script&lang=js"
export * from "./WalletDeposit.vue?vue&type=script&lang=js"

import "./WalletDeposit.vue?vue&type=style&index=0&id=ce788260&scoped=true&lang=css"
import "./WalletDeposit.vue?vue&type=style&index=1&id=ce788260&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce788260"]])

export default __exports__